<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <v-form @submit.prevent="handleSubmit" ref="form" lazy-validation>
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="اطلاعات فروشگاه">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام فروشگاه"
                                                    name="shop_name"
                                                    v-model="form.shop_name"
                                                    type="text"
                                                    required
                                                    @change="form.more_setting.main_title = form.shop_name + ` | فروشگاه محصولات چاپی`"
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-autocomplete
                                                    :items="store_categories"
                                                    autocomplete
                                                    item-text="name"
                                                    item-value="c_id"
                                                    label="موضوع فروشگاه"
                                                    required
                                                    v-model.number="form.store_categories"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-autocomplete
                                                    :items="templates"
                                                    autocomplete
                                                    item-text="name_fa"
                                                    item-value="name"
                                                    label="قالب فروشگاه"
                                                    required
                                                    v-model.number="form.template"
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex>
                                            <v-chip class="pb-3 pt-3" color="#eeeeee">
                                                <v-flex xs5>
                                                    <v-autocomplete
                                                            :items="domains"
                                                            autocomplete
                                                            item-text="name"
                                                            item-value="id"
                                                            label="دامنه"
                                                            required
                                                            @change="fixdomain"
                                                            v-model="form.domain_ltd"
                                                    ></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs7 style="position:relative;">
                                                        <v-text-field
                                                                slot="activator"
                                                                label="آدرس"
                                                                name="domain"
                                                                autocomplete="off"
                                                                v-model="form.domain"
                                                                data-ltr
                                                                :hint="form.domain_ltd === 'دامنه اختصاصی'?'آدرس دامنه بدون www و http://':'آدرس زیر دامنه شامل حروف/عدد لاتین و -'"
                                                                type="text"
                                                                @change="fixdomain"
                                                                :rules="[rules.required]"
                                                        ></v-text-field>
                                                    <v-icon style="position: absolute; left:10px;top: 5px;"
                                                            :color="domain_status === 'cancel'?'red':'green'">
                                                        {{domain_status}}
                                                    </v-icon>
                                                </v-flex>
                                            </v-chip>
                                            <v-layout style="text-align: center;margin-top:10px">
                                                <a target="_blank" style="margin:0 auto" v-if="form.domain.length >0" :href="`https://`+mergedDomain">{{mergedDomain}}</a>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-layout>
                                                <v-flex>
                                                    <v-alert :value="form.domain_ltd === 'دامنه اختصاصی'" color="blue">
                                                        در صورت انتخاب گزینه دامنه اختصاصی، نیم‌سرورهای دامنه خود را بر
                                                        روی موارد ذیل تنظیم نمایید:
                                                        <br>
                                                        ns1.chapchi.com
                                                        <br>
                                                        ns2.chapchi.com
                                                        <br>
                                                        توضیحات کامل و دقیق‌تر در <a style="color:yellow"
                                                                                     target="_blank"
                                                                                     href="/blog/%d9%86%d8%ad%d9%88%d9%87-%d8%ab%d8%a8%d8%aa-%d8%af%d8%a7%d9%85%d9%86%d9%87-%d8%a7%d8%ae%d8%aa%d8%b5%d8%a7%d8%b5%db%8c-%d9%88-%d8%a7%d8%aa%d8%b5%d8%a7%d9%84-%d8%a8%d9%87-%da%86%d8%a7%d9%be%da%86%db%8c.html">(صفحه
                                                        راهنما)</a> بیان گردیده است.
                                                    </v-alert>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs6>
                                            <ImageSelect
                                                    v-model="picture"
                                                    label="تصویر نمایه‌ی فروشگاه"
                                                    format="jpg,png"
                                                    :height="512"
                                                    :width="512"
                                                    size-min
                                                    aspect-ratio
                                                    :max-size="512"
                                            ></ImageSelect>
                                        </v-flex>
                                        <v-flex xs6>
                                            <ImageSelect
                                                    v-model="favicon"
                                                    label="فایل favicon"
                                                    format="png"
                                                    :height="32"
                                                    :width="32"
                                                    :max-size="100"
                                                    size-forced
                                            ></ImageSelect>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout>
                                        <div>
                                            <v-radio-group v-model="form.is_active">
                                                <v-layout>
                                                    <v-flex>
                                                        <v-radio
                                                                label="نمایش فروشگاه"
                                                                value="Y"
                                                                color="green"
                                                        ></v-radio>
                                                    </v-flex>
                                                    <v-flex>
                                                        <v-radio
                                                                label="عدم نمایش فروشگاه"
                                                                value="N"
                                                                color="red"
                                                        ></v-radio>
                                                    </v-flex>
                                                </v-layout>
                                            </v-radio-group>
                                        </div>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="اطلاعات تکمیلی">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="عنوان صفحه"
                                                    name="phone"
                                                    v-model="form.more_setting.main_title"
                                                    type="text"
                                                    maxlength="72"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="شماره تلفن نمایشی"
                                                    name="phone"
                                                    v-model="form.more_setting.phone"
                                                    type="text"
                                                    maxlength="23"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام کاربری توییتر"
                                                    name="twitter"
                                                    v-model="form.more_setting.twitter"
                                                    type="text"
                                                    @change="form.more_setting.twitter = form.more_setting.twitter.replace('https://twitter.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام کاربری اینستاگرام"
                                                    name="instagram"
                                                    v-model="form.more_setting.instagram"
                                                    type="text"
                                                    @change="form.more_setting.instagram = form.more_setting.instagram.replace('https://instagram.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام کاربری فیسبوک"
                                                    name="facebook"
                                                    v-model="form.more_setting.facebook"
                                                    type="text"
                                                    @change="form.more_setting.facebook = form.more_setting.facebook.replace('https://facebook.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام کاربری دریبل"
                                                    name="dribbble"
                                                    v-model="form.more_setting.dribbble"
                                                    type="text"
                                                    @change="form.more_setting.dribbble = form.more_setting.dribbble.replace('https://dribbble.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="آدرس تلگرام"
                                                    name="telegram"
                                                    v-model="form.more_setting.telegram"
                                                    type="text"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="آدرس یوتیوب"
                                                    name="youtube"
                                                    v-model="form.more_setting.youtube"
                                                    type="text"
                                                    @change="form.more_setting.youtube = form.more_setting.youtube.replace('http://','').replace('https://','').replace('youtube.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-textarea
                                                    label="اسکریپت‌ها"
                                                    v-model="form.more_setting.scripts"
                                                    placeholder="کد ای‌نماد، گوگل آنالتیکز و..."
                                                    data-ltr
                                                    rows="16"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout>
                                        <div>
                                            <v-btn
                                                    :loading="loading"
                                                    :disabled="loading"
                                                    color="green"
                                                    class="white--text"
                                                    large
                                                    type="submit"
                                            >
                                                ثبت
                                                &nbsp;
                                                <v-icon left dark>save</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import ImageSelect from '@/components/ImageSelect';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  components: {
    VWidget,
    ImageSelect
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      store_categories: [],
      templates: [],
      picture: null,
      favicon: null,
      form: {
        res_id: 0,
        store_categories: 0,
        domain_ltd: 'دامنه اختصاصی',
        domain: '',
        shop_name: '',
        template: 'default',
        is_active: 'Y',
        more_setting: {
          main_title: '',
          twitter: '',
          telegram: '',
          instagram: '',
          facebook: '',
          dribbble: '',
          youtube: '',
          phone: '',
          scripts: '',
        }
      },
      resellers: [],
      domains: [],
      domain_status: 'cancel',
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {
    mergedDomain () {
      return this.form.domain_ltd === 'دامنه اختصاصی' ? this.form.domain : this.form.domain + '.' + this.form.domain_ltd;
    }
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 1000);
      this.loader = null;
    }
  },
  mounted: function () {
    this.axios.get('/reseller/domains/')
      .then(response => {
        let data = [{ name: 'دامنه اختصاصی' }];
        if (response.data.Data.length > 0) {
          this.form.domain_ltd = response.data.Data[0].name;
        }

        response.data.Data.forEach(d => {
          d.id = d.name;
          d.name = d.name + '.';
          data.push(d);
        });
        this.domains = data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/store_categories/')
      .then(response => {
        this.store_categories = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/templates/')
      .then(response => {
        this.templates = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    fixdomain () {
      this.form.domain = this.form.domain.replace('http://', '', -1).replace('https://', '', -1).replace('www.', '', -1).replace('/', '', -1);
      let test = false;
      if (this.form.domain.length === 0) {
        return;
      }
      if (this.form.domain_ltd === 'دامنه اختصاصی') {
        test = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/.test(this.form.domain);
      } else {
        test = /^([a-z A-Z 0-9 -]){3,64}$/.test(this.form.domain);
      }
      if (!test) {
        this.snackbar.snackbar = true;
        this.snackbar.text = 'دامنه غیر معتبر است';
        this.snackbar.color = 'red';
        this.domain_status = 'cancel';
        return;
      }
      this.axios.post('/reseller/check_domain/', {
        domain: this.form.domain,
        domain_ltd: this.form.domain_ltd,
        store_id: 0
      })
        .then(response => {
          this.domain_status = 'check_circle';
        })
        .catch(error => {
          this.domain_status = 'cancel';
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    handleSubmit () {
      /* if (this.picture === null) {
        this.snackbar.text = 'فایل تصویر نمایه‌ی فروشگاه را انتخاب نمایید.';
        this.snackbar.y = 'top';
        this.snackbar.color = 'red';
        this.snackbar.snackbar = true;
        return;
      }
      if (this.favicon === null) {
        this.snackbar.text = 'فایل favicon را انتخاب کنید.';
        this.snackbar.y = 'top';
        this.snackbar.color = 'red';
        this.snackbar.snackbar = true;
        return;
      } */
      if (!this.$refs.form.validate()) {
        this.snackbar.text = 'فیلدهای اجباری را پر نمایید.';
        this.snackbar.y = 'top';
        this.snackbar.color = 'red';
        this.snackbar.snackbar = true;
        return;
      }
      this.loader = 'loading';
      this.axios.post('/reseller/stores', this.form)
        .then(response => {
          // Response Submit Method
          let formData = new FormData();
          if (this.picture !== null) {
            formData.append('picture', this.picture);
          }
          if (this.favicon !== null) {
            formData.append('favicon', this.favicon);
          }
          if (this.favicon !== null || this.picture !== null) {
            this.axios.put('/reseller/stores/edit_picture/' + response.data, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(() => {
              this.snackbar.text = 'با موفقیت انجام شد.';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'success';
              this.snackbar.snackbar = true;
              this.loading = false;
              setTimeout(() => {
                this.$router.push('/pages/template_setting/' + response.data);
              }, 1000);
            }).catch(() => {
              this.snackbar.text = 'ناتوان در ارسال تصاویر';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'error';
              this.snackbar.snackbar = true;
              this.loading = false;
              this.$router.push('/pages/store/edit/' + response.data);
            });
          } else {
            this.snackbar.text = 'با موفقیت انجام شد.';
            this.snackbar.y = 'bottom';
            this.snackbar.color = 'success';
            this.snackbar.snackbar = true;
            this.$router.push('/pages/store/edit/' + response.data);
          }
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/store/add.vue